export default "__VITE_ASSET__C9r6rSfH__"